import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "mm-sequencing"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "question"
};
const _hoisted_6 = {
  class: "answer-option"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "menu"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default"), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].choiceList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("p", {
      key: 'questionIndex' + questionIndex,
      innerHTML: String.fromCharCode(65 + questionIndex) + '. ' + questionItem.choiceText
    }, null, 8, _hoisted_7);
  }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].questionList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "answer",
      key: 'que' + questionIndex
    }, [_createElementVNode("div", _hoisted_8, _toDisplayString(questionIndex + $props.questionInfo.menu), 1), _createElementVNode("p", null, "Speaker" + _toDisplayString(questionIndex + 1) + "：", 1), _createVNode(_component_el_select, {
      modelValue: $setup.answer[questionItem.questionId],
      "onUpdate:modelValue": $event => $setup.answer[questionItem.questionId] = $event,
      class: "m-2",
      placeholder: " ",
      size: "small",
      onChange: $setup.setAnswer
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].choiceList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: String.fromCharCode(index - 0 + 65) + 'fromCharCode',
          label: $setup.clearText(item.choiceText),
          value: String.fromCharCode(index - 0 + 65)
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]);
  }), 128))])]);
}